<mat-button-toggle
  #matToggleButton
  class="u-toggle-button"
  [checked]="checked()"
  [disabled]="stateElement() === 'disabled'"
  [ngClass]="styleClass()"
  (change)="onToggleChange($event)"
  (click)="$event.stopPropagation()"
>
  @if (currentIcon()) {
    <i [class]="currentIcon() + ' p-button-icon p-button-icon-left'"></i>
  }
  @if (currentLabel()) {
    <span class="toggle-label">{{ currentLabel() }}</span>
  }
</mat-button-toggle>
